import $ from "jquery";
import { gsap } from "gsap";

export function tracker_handler(event) {
    gsap.to('.tracker', .3, { x: event.clientX, y: event.clientY, delay: .05 })
};